<div class="alert-box">
    <p *ngFor="let alert of alerts">
        <ngb-alert [type]="alert.type" (close)="removeAlert(alert)">
            {{ alert.message }}
        </ngb-alert>
    </p>
</div>
